import {useMutation, useQueryClient} from '@tanstack/react-query'
import {t} from 'i18next'
import {useSnackbar} from 'notistack'

import {api} from '../../../../../App.store'
import {OrderChangeConfig, OrderChangeCreateConfig} from '../types/OrderChangeConfig'

import {OrderChangeConfigQueryKey, ProductConfigsQueryKey} from './queryKeys'

const deleteOrderChangeConfig = async (configId: string) => {
  await api.delete<OrderChangeConfig[]>(`product-configs/order-management-settings/${configId}`)
  return configId
}

const createOrderChangeConfig = async (orderChangeConfig: OrderChangeCreateConfig) => {
  await api.post<OrderChangeCreateConfig>(
    '/product-configs/order-management-settings',
    orderChangeConfig
  )
  return orderChangeConfig
}

const editOrderChangeConfig = async (orderChangeConfig: OrderChangeConfig) => {
  await api.put<OrderChangeConfig[]>(
    `/product-configs/order-management-settings/${orderChangeConfig.id}`,
    orderChangeConfig
  )
  return orderChangeConfig
}
type MutationType = 'create' | 'edit' | 'delete'

// TODO: unify into 1 hook with a parameter for the mutation type + make it properly typed
export const useOrderChangeConfigsCreateMutation = () => {
  const queryClient = useQueryClient()
  const {enqueueSnackbar} = useSnackbar()

  return useMutation(
    createOrderChangeConfig,
    getMutationHandlers(queryClient, enqueueSnackbar, 'create')
  )
}
export const useOrderChangeConfigsEditMutation = () => {
  const queryClient = useQueryClient()
  const {enqueueSnackbar} = useSnackbar()

  return useMutation(
    editOrderChangeConfig,
    getMutationHandlers(queryClient, enqueueSnackbar, 'edit')
  )
}
export const useOrderChangeConfigsDeleteMutation = () => {
  const queryClient = useQueryClient()
  const {enqueueSnackbar} = useSnackbar()

  return useMutation(
    deleteOrderChangeConfig,
    getMutationHandlers(queryClient, enqueueSnackbar, 'delete')
  )
}

const getMutationHandlers = (queryClient, enqueueSnackbar, mutationType: MutationType) => ({
  onSuccess: () => {
    const successMessageKey = {
      create: 'configurations.hconnect.orderManagement.configurationList.createSuccess',
      edit: 'configurations.hconnect.orderManagement.configurationList.editSuccess',
      delete: 'configurations.hconnect.orderManagement.configurationList.deleteSuccess'
    }[mutationType]

    enqueueSnackbar(t(successMessageKey), {variant: 'success'})
    queryClient.invalidateQueries([ProductConfigsQueryKey, OrderChangeConfigQueryKey])
  },
  onError: (error: any) => {
    const errorMessageKey = {
      create: 'configurations.hconnect.orderManagement.configurationList.createError',
      edit: 'configurations.hconnect.orderManagement.configurationList.editError',
      delete: 'configurations.hconnect.orderManagement.configurationList.deleteError'
    }[mutationType]

    enqueueSnackbar(t(errorMessageKey), {variant: 'error'})
    console.error('Mutation error:', error)
  }
})
